import { render, staticRenderFns } from "./BatchList.vue?vue&type=template&id=397b331b&"
import script from "./BatchList.vue?vue&type=script&lang=js&"
export * from "./BatchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../code/tibava/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports